import { render, staticRenderFns } from "./SGPBotaoVoltarComponent.vue?vue&type=template&id=18a4295a&scoped=true"
import script from "./SGPBotaoVoltarComponent.vue?vue&type=script&lang=js"
export * from "./SGPBotaoVoltarComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPBotaoVoltarComponent.vue?vue&type=style&index=0&id=18a4295a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4295a",
  null
  
)

export default component.exports